
<div class="kt-header__topbar">

	<!-- <kt-user-profile></kt-user-profile> -->
	<!-- <kt-notification [bgImage]="'./assets/media/misc/bg-1.jpg'" [pulse]="true" [skin]="'dark'" [icon]="'./assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true"></kt-notification> -->
	<!--end: Notifications -->
	<!--begin: Quick actions -->
	<!-- <kt-quick-action [bgImage]="'./assets/media/misc/bg-2.jpg'" [skin]="'dark'" [icon]="'./assets/media/icons/svg/Media/Equalizer.svg'" [useSVG]="true"></kt-quick-action> -->
	<!--end: Quick actions -->
	<!--begin: My Cart -->
 <!--<kt-cart [bgImage]="'./assets/media/misc/bg-1.jpg'" [icon]="'./assets/media/icons/svg/Shopping/Cart%233.svg'" [useSVG]="true"></kt-cart>-->
	<!--end: My Cart -->
	<!--begin: Quick panel toggler -->
	<!-- <div class="kt-header__topbar-item kt-header__topbar-item--quick-panel" data-placement="bottom" ngbTooltip="Quick panel">
		<span class="kt-header__topbar-icon" id="kt_quick_panel_toggler_btn">
			<span class="kt-svg-icon" [inlineSVG]="'./assets/media/icons/svg/Layout/Layout-4-blocks.svg'"></span>
		</span>
	</div> -->
	<!--end: Quick panel toggler -->
	
	<!--begin: Language bar -->
	<!-- <kt-language-selector></kt-language-selector> -->
	<!-- <div class="dropdown">
		<button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		  Dropdown button
		</button>
		<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
		  <a class="dropdown-item" href="#">Action</a>
		  <a class="dropdown-item" href="#">Another action</a>
		  <a class="dropdown-item" href="#">Something else here</a>
		</div>
	  </div> -->


			<!--topbar adding notification-->
			<!-- <kt-notification  class="user-notifications"   [pulse]="true" [skin]="'dark'" [icon]="'fas fa-bell custon-iconic'"></kt-notification> -->

  <!--old dropdown-->
	<!-- <div class="dropdown">
	   <a  href="javascript::"  (click)="myFunction()" class="myprofile-icon">
		  <i class="fas fa-user-circle"></i>
	   </a>
	  <div id="myDropdown" class="dropdown-content">
		<a>
		  <i class="fas fa-user" routerLink="/profile"></i>Profile</a>
		<a> 
		<i class="fas fa-unlock" routerLink="/changepassword"></i>Change Password</a>
		<a (click)="logout()">
		  <i class="fas fa-sign-out-alt"></i>Logout</a>
	  </div>
	</div> -->


	<!--dropdown with outside click toggles-->


	<!-- <div class="dropdown"> -->
			<!-- <button class="btn btn-secondary dropdown-toggle profile-dropdown" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> -->
					<div class="logout-overall" href="#" (click)="logout()"> 
						<i class="fas fa-sign-out-alt custom-icons"></i>
					</div>
			<!-- </button> -->
			<!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
				<a class="dropdown-item" href="#" routerLink="/profile"> <i class="fas fa-user" ></i>Profile</a>
				<a class="dropdown-item" href="#" routerLink="/changepassword">	<i class="fas fa-unlock"></i>Change Password</a>
				<a class="dropdown-item" href="#" (click)="logout()"> <i class="fas fa-sign-out-alt"></i>Logout</a>
			</div>
		</div> -->

		
	


	
	<!--end: Language bar -->
	<!--begin: User bar -->
	<!-- <kt-user-profile1></kt-user-profile1> -->
	<!--end: User bar -->
	
</div>
